/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
/* import "@fancyapps/fancybox"; */


window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*
const app = new Vue({
    el: '#app'
});
*/

$(".nav-tabs li.nav-item a.nav-link").click(function () {
    $(".nav-tabs li.nav-item a.nav-link").removeClass('active');
});

/* $('a.fancybox-gallery').fancybox({
    'transitionIn'	:	'elastic',
    'transitionOut'	:	'elastic',
    'speedIn'		:	600, 
    'speedOut'		:	200, 
    'overlayShow'	:	false
}); */

import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

// 2021-2027 EU development cycle
const imageLinkContainer2 = document.createElement('div');
imageLinkContainer2.style.display = 'flex';
imageLinkContainer2.style.alignItems = 'center';
imageLinkContainer2.style.width = '100%';

const imageLinkNode2 = document.createElement('a');
imageLinkNode2.href = "/eu-palyazatok/2021-2027-unios-fejlesztesi-ciklus";
imageLinkNode2.style.flexGrow = "1";

const imgNode2 = document.createElement('img');
imgNode2.src = "/img/szechenyi-terv.jpg";
imgNode2.alt = "Széchenyi terv";
imgNode2.style.maxHeight = "60.5px";
imgNode2.style.display = "block";

imageLinkNode2.appendChild(imgNode2);
imageLinkContainer2.appendChild(imageLinkNode2);

const top = Toastify({
    node: imageLinkContainer2,
    duration: -1,
    close: true,
    gravity: "top",
    position: "right",
    className: "custom-sticky-banner top-banner"
});

// RRF kedvezményezetti infoblokk
const imageLinkContainer3 = document.createElement('div');
imageLinkContainer3.style.display = 'flex';
imageLinkContainer3.style.alignItems = 'center';
imageLinkContainer3.style.width = '100%';

const imageLinkNode3 = document.createElement('a');
imageLinkNode3.href = "/eu-palyazatok/2021-2027-unios-fejlesztesi-ciklus";
imageLinkNode3.style.flexGrow = "1";

const imgNode3 = document.createElement('img');
imgNode3.src = "/img/rrf-kedvezmenyezetti-infoblokk.jpg";
imgNode3.alt = "RRF kedvezményezetti infoblokk";
imgNode3.style.maxHeight = "64px";
imgNode3.style.display = "block";

imageLinkNode3.appendChild(imgNode3);
imageLinkContainer3.appendChild(imageLinkNode3);

const middle = Toastify({
    node: imageLinkContainer3,
    duration: -1,
    close: true,
    gravity: "top",
    position: "right",
    className: "custom-sticky-banner middle-banner"
});

// 2014-2020 EU development cycle
const imageLinkContainer = document.createElement('div');
imageLinkContainer.style.display = 'flex';
imageLinkContainer.style.alignItems = 'center';
imageLinkContainer.style.width = '100%';

const imageLinkNode = document.createElement('a');
imageLinkNode.href = "/eu-palyazatok/2014-2020-unios-fejlesztesi-ciklus";
imageLinkNode.style.flexGrow = "1";

const imgNode = document.createElement('img');
imgNode.src = "/img/szechenyi-2020.png";
imgNode.alt = "Széchenyi 2020";
imgNode.style.maxHeight = "175px";
imgNode.style.display = "block";

imageLinkNode.appendChild(imgNode);
imageLinkContainer.appendChild(imageLinkNode);

const bottom = Toastify({
    node: imageLinkContainer,
    duration: -1,
    close: true,
    gravity: "top",
    position: "right",
    className: "custom-sticky-banner bottom-banner",
});

bottom.showToast();
middle.showToast();
top.showToast();